// Public browser configuration. Never put server secrets here.
const supplied = typeof window === "undefined" ? {} : (window.__APP_CONFIG__ || {});
const runtimeConfig = {
  REACT_APP_API_URI: supplied.REACT_APP_API_URI !== undefined ? supplied.REACT_APP_API_URI : (process.env.REACT_APP_API_URI || "/api"),
  REACT_APP_WEB_API_URI: supplied.REACT_APP_WEB_API_URI !== undefined ? supplied.REACT_APP_WEB_API_URI : (process.env.REACT_APP_WEB_API_URI || ""),
  REACT_APP_STRIPE_PK: supplied.REACT_APP_STRIPE_PK !== undefined ? supplied.REACT_APP_STRIPE_PK : (process.env.REACT_APP_STRIPE_PK || ""),
  REACT_APP_PAYPAL_CLIENT_ID: supplied.REACT_APP_PAYPAL_CLIENT_ID !== undefined ? supplied.REACT_APP_PAYPAL_CLIENT_ID : (process.env.REACT_APP_PAYPAL_CLIENT_ID || ""),
};
export default runtimeConfig;
